import type { DragEndEvent } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";

/** Reorder a list after a drag end, or return null when no move occurred. */
export function reorderByDragEnd<T>(
  items: readonly T[],
  event: DragEndEvent,
  getItemId: (item: T) => string | number,
): T[] | null {
  const { active, over } = event;
  if (!over || active.id === over.id) {
    return null;
  }

  const oldIndex = items.findIndex((item) => getItemId(item) === active.id);
  const newIndex = items.findIndex((item) => getItemId(item) === over.id);
  if (oldIndex === -1 || newIndex === -1) {
    return null;
  }

  return arrayMove([...items], oldIndex, newIndex);
}

/** Reorder string ids (e.g. table column preferences). */
export function reorderIdsByDragEnd(
  ids: readonly string[],
  event: DragEndEvent,
): string[] | null {
  const { active, over } = event;
  if (!over || active.id === over.id) {
    return null;
  }

  const activeId = String(active.id);
  const overId = String(over.id);
  const oldIndex = ids.indexOf(activeId);
  const newIndex = ids.indexOf(overId);
  if (oldIndex < 0 || newIndex < 0) {
    return null;
  }

  return arrayMove([...ids], oldIndex, newIndex);
}
